/**
 * Maps underlying group names from English to Italian.
 * @param groupName The English group name.
 * @returns The Italian translation or the original name if no translation is found.
 */
export const mapGroupNameToItalian = (groupName: string): string => {
  switch (groupName) {
     case 'MutualFunds':
       return 'Fondi comuni di investimento';
      case 'BankAccounts':
          return 'Conti correnti';
      case 'ETF':
          return 'ETF e altri strumenti';
      case 'Shares':
          return 'Azioni';
      case 'Bonds':
        return 'Obbligazioni';
    default:
      return groupName;
  }
};


const groupSortOrder: string[] = [
  'MutualFunds',
  'Shares',
  'ETF',
  'BankAccounts'
];

// Interfaccia più specifica per i gruppi per risolvere l'errore TypeScript.
interface UnderlyingGroup {
  name: string;
  underlying: any[];
  [key: string]: any;
}

/**
 * Ordina i gruppi dei sottostanti in base all'ordine predefinito in groupSortOrder.
 * @param groups L'array dei gruppi dei sottostanti.
 * @returns Un nuovo array con i gruppi ordinati.
 */
export const sortUnderlyingGroups = (groups: UnderlyingGroup[]): UnderlyingGroup[] => {
  if (!groups || groups.length === 0) {
    return groups || [];
  }

  // Ordina i prodotti all'interno di ogni gruppo alfabeticamente per productName
  const processedGroups = groups.map(group => ({
    ...group,
    underlying: [...group.underlying].sort((a, b) => 
      (a.productName || '').localeCompare(b.productName || '')
    )
  }));

  if (groupSortOrder.length === 0) {
    return processedGroups;
  }

  const sortedGroups = [...processedGroups].sort((a, b) => {
    const indexA = groupSortOrder.indexOf(a.name);
    const indexB = groupSortOrder.indexOf(b.name);

    if (indexA === -1 && indexB === -1) return 0; // Entrambi non sono nella lista, mantieni l'ordine relativo
    if (indexA === -1) return 1; // 'a' non è nella lista, mettilo alla fine
    if (indexB === -1) return -1; // 'b' non è nella lista, mettilo alla fine

    return indexA - indexB;
  });
  return sortedGroups;
};
